'use strict';

angular.module('administrationPortal').controller('AdminUsersIndexCtrl', ['$adminUserDataService', function ($adminUserDataService) {
    const self = this;
    self.usernameQuery = $adminUserDataService.getUsernameQuery();

    self.setUsernameQuery = (username) => {
        $adminUserDataService.setUsernameQuery(username);
        self.usernameQuery = $adminUserDataService.getUsernameQuery();
    };

    self.menuItems = [
        {name: 'User details', state: 'details'},
        {name: 'Submissions', state: 'submissions'},
        {name: 'Sync data', state: 'sync'},
    ];
}]);
